/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 orion_14slotrack.glb --transform --simplify --ratio 0.5 --draco 
Files: orion_14slotrack.glb [1.05MB] > C:\Users\eviei\Desktop\MODELOSORION\orion_14slotrack-transformed.glb [473.06KB] (55%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function Rack14slotModel(pos) {
  const { nodes, materials } = useGLTF('/models/rack14slot2-transformed.glb')
  return (
    <group position={[198.5,-8.5,4]} dispose={null} rotation={[Math.PI/2,0,0]} >
      <mesh geometry={nodes.CHICS_14_Slot_Backplane_Stiffener_1.geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes.CHICS_14_Slot_Backplane_Stiffener_2.geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/rack14slot2-transformed.glb')
